import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Croppie from 'croppie';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { CommonUploadImageService } from 'src/app/services/common-upload-image.service';
import { ToastService } from 'src/app/services/toast.service';
import { timeout, TimeoutError } from 'rxjs';


/** Give up waiting after this long, so the window can't sit on "Saving…"
 *  forever when the server doesn't answer (it lets the user try again). */
const UPLOAD_TIMEOUT_MS = 60_000;

@Component({
    selector: 'app-commonuploadimagemodel',
    templateUrl: './commonuploadimagemodel.component.html',
    styleUrls: ['./commonuploadimagemodel.component.scss'],
    standalone: false
})
export class CommonuploadimagemodelComponent implements OnInit,AfterViewInit {

  @Input() image: string;
  @Input() playerUpdate:any
  @Input() gameDetailUpdate:any
  @Input() masterUpdate:any
  path = 'ip'; // Make sure to replace 'ip' with your actual path
  selectedImage: any;
  user_id:number 
  playerdetailform: FormGroup;
  @ViewChild('croppieElement') croppieElement: ElementRef;
  croppieInstance: Croppie;
  /** A picture is in the cropper (the current one, or one just chosen). */
  hasPicture = false;
  /** A new picture was chosen: only then is there something to save. */
  picked = false;
  uploading = false;
  errorMessage = '';

  constructor(
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private commonImageUploadService:CommonUploadImageService,
    private currentUserService:CurrentUserService,
    private toastService: ToastService,
    private cdr: ChangeDetectorRef
  ) {}
  ngAfterViewInit(): void {
      this.croppieInstance = new Croppie(this.croppieElement.nativeElement, {
        viewport: { width: 180, height: 180, type: 'circle' },
        boundary: { width: 240, height: 240 },
        showZoomer: true,
        enableOrientation: true ,
      });

      if (this.selectedImage) {
        this.hasPicture = true;
        this.croppieInstance.bind({ url: this.selectedImage });
        this.cdr.detectChanges();
      }

        
  }

  ngOnInit(): void {
   
    this.playerdetailform = this.formBuilder.group({
      image: [this.image?this.image:null, Validators.required], // Set the default value to null or an empty string
    });
    this.currentUserService.currentUser.subscribe((data)=>{
      if(data){

        this.user_id = data.id;
        this.cdr.detectChanges();
      }
    })
  }

  handleFileInput(event: any): void {
    const file = event.target.files[0];
  
    if (file) {
      const reader = new FileReader();
  
      reader.onloadend = () => {
        // Set the base64-encoded image data to the form control
  
        this.selectedImage = reader.result;
        // Put the picture in the form (Save stayed greyed out when this only
        // cleared the "required" error by hand).
        this.playerdetailform.controls['image'].setValue(reader.result);
        this.hasPicture = true;
        this.picked = true;
        this.errorMessage = '';
        // Rebind the Croppie instance with the new image
        this.croppieInstance.bind({
          url: reader.result,
        });
      
          this.cdr.detectChanges();};
      reader.readAsDataURL(file);
    }
  }
  

  uploadImage(): void {
    if (!this.picked || this.uploading) return;
    this.uploading = true;
    this.errorMessage = '';
    this.cdr.detectChanges();
    const failed = (err?: any) => {
      this.uploading = false;
      this.errorMessage = err instanceof TimeoutError
        ? "Saving is taking too long. Please check your connection and try again."
        : err?.error?.error || err?.error?.message || "We couldn't save the picture. Please try again.";
      this.cdr.detectChanges();
    };
    this.croppieInstance.result({ type: 'base64', size: 'viewport' }).then((result) => {
      if (result) {
      
        this.playerdetailform.controls['image'].setValue(result);
        this.playerdetailform.updateValueAndValidity()
        
        if (!this.playerUpdate && !this.masterUpdate && !this.gameDetailUpdate) {
          this.commonImageUploadService.userImageUpload({ ...this.playerdetailform.value, user_id: Number(this.user_id) }).pipe(timeout(UPLOAD_TIMEOUT_MS)).subscribe({
            next: (data) => {
              this.uploading = false;
              if (data) this.activeModal.close(data);
              this.cdr.detectChanges();
            },
            error: failed,
          });
        }
        else if(this.playerUpdate && this.playerUpdate!=='first_upload'){
          this.commonImageUploadService.playerImageUpload({image:this.playerdetailform.value.image,character_id:this.playerUpdate}).subscribe((res) => {
            if(res){
              this.toastService.showSuccess('Profile picture updated.','success')
              this.activeModal.close({res:result,isFirstUpload:false})
            }
          
          this.cdr.detectChanges();})
            // Reload the list
        }
        else if(!this.playerUpdate && this.masterUpdate){
          this.commonImageUploadService.gameMasterPartyTokenUpload({gamemasterid:this.masterUpdate,image:this.playerdetailform.value.image}).pipe(timeout(UPLOAD_TIMEOUT_MS)).subscribe({
            next: (res) => {
              this.uploading = false;
              this.toastService.showSuccess('Picture updated.', 'success');
              this.activeModal.close(res);
              this.cdr.detectChanges();
            },
            error: failed,
          });
        }
        else if(this.gameDetailUpdate){
          this.commonImageUploadService.gamedetailimgupload({game_id:this.gameDetailUpdate,image:this.playerdetailform.value.image}).pipe(timeout(UPLOAD_TIMEOUT_MS)).subscribe({
            next: (res) => {
              this.uploading = false;
              this.toastService.showSuccess('Game picture updated.', 'success');
              this.activeModal.close(res);
              this.cdr.detectChanges();
            },
            error: failed,
          });
        }
        else if(this.playerUpdate && this.playerUpdate==='first_upload'){
          this.activeModal.close({res:result,isFirstUpload:true})
        }
      } else {
        failed();
      }
    }).catch(failed);
  }

  closemodel(): void {
    this.activeModal.close();
  }

}
